import * as ActionType from '../../constants/actionType';

export const addTemporaryState = (name, state) => ({
  type: ActionType.ADD_TEMPORARY_STATE,
  name,
  state,
});

export const removeTemporaryState = (name) => ({type: ActionType.REMOVE_TEMPORARY_STATE, name});

export const resetTemporaryState = () => ({type: ActionType.RESET_TEMPORARY_STATE});

export const restoreTemporaryState = (state) => ({
  type: ActionType.RESTORE_TEMPORARY_STATE,
  state,
});
